export default __webpack_public_path__ + "static/media/hypertest-feature.3c208ab5.svg";